import React from "react";
import general from "../styles/General.module.scss";

const Baustellenadresse = ({ handleInputChange, inputSummary }) => {
  return (
    <>
      <div className={general.inputContainer}>
        <p className={general.bold}>Adresse der Baustelle*</p>

        <label>Straße/Hausnummer*</label>
        <input
          type="text"
          name="strasse-baustellenadresse"
          onChange={(e) =>
            handleInputChange("strasse-baustellenadresse", e.target.value)
          }
          value={inputSummary["strasse-baustellenadresse"]}
          className={`${general.mediumInput + " required"}`}
        />
      </div>

      <div className={general.inputContainer}>
        <label>PLZ*</label>
        <input
          type="text"
          name="plz-baustellenadresse"
          onChange={(e) =>
            handleInputChange("plz-baustellenadresse", e.target.value)
          }
          style={{ maxWidth: "80px" }}
          value={inputSummary["plz-baustellenadresse"]}
          className={`${general.smallInput + " required"}`}
        />
      </div>

      <div className={general.inputContainer}>
        <label>Ort*</label>
        <input
          type="text"
          name="ort-baustellenadresse"
          onChange={(e) =>
            handleInputChange("ort-baustellenadresse", e.target.value)
          }
          value={inputSummary["ort-baustellenadresse"]}
          className={`${general.mediumInput + " required"}`}
        />
      </div>
    </>
  );
};

export default Baustellenadresse;
